import { isAlpha } from "configuration/endpoints";
import { USER_ROLES } from "model/auth";
import { ILocationState } from "model/routing";
import React from "react";
import { Navigate, useLocation } from "react-router";
import {
  getUserInfo,
  useIsAdminCheck,
  useIsLoggedIn,
  useRole,
} from "redux/auth";
import { useAppDispatch } from "redux/store";

function AuthProvider({ children }) {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const isLoggedIn = useIsLoggedIn();
  const isAdmin = useIsAdminCheck();
  const role = useRole();

  React.useEffect(
    () => {
      dispatch(getUserInfo());
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // redirect alpha->prod if user acc is not ADMIN
  React.useEffect(() => {
    if (
      isLoggedIn &&
      isAlpha &&
      isAdmin === false &&
      role !== USER_ROLES.FINANCE_ADMIN
    ) {
      const url = new URL(window.location.href);
      url.hostname = window.location.hostname.replace("-alpha", "");
      window.location.href = url.href;
    }
  }, [isAdmin, isLoggedIn]);

  // redirect only if isLoggedIn is false, not if undefined
  if (isLoggedIn === false) {
    const locationState: ILocationState = {
      referrer: `${location.pathname}${location.search ?? ""}`,
    };
    return (
      <Navigate
        replace
        to="/login/"
        state={locationState}
      />
    );
  }

  return isLoggedIn === true && role ? <>{children}</> : null;
}

export default AuthProvider;
